import { FLYBITS } from '../../../constants';
import axios from '../../../utils/axios';
import { ISFConfig } from '../types/config';

export const updateConfig = async (accessToken: string, tenantId: string, partialConfig: any): Promise<ISFConfig> => {
    const response = await axios.put(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations`, {
        ...partialConfig,
        name: 'salesforce',
    }, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}

export const getConfig = async (accessToken: string, tenantId: string): Promise<ISFConfig> => {
    const response = await axios.get(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations/salesforce?initialize=true`, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}



// WEBPACK FOOTER //
// ./src/sub-projects/salesforce/services/config.ts